"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={size:20,page:0};exports.DEFAULT_PAGEABLE_VALUES=e;
